import { createSlice } from "@reduxjs/toolkit";
import { fetchTrialBalance } from "./trialBalanceThunk";

const initialState = {
  balances: {},
  loading: false,
  error: null,
  filters: {
    filterType: "Lifetime",
    fromDate: null,
    toDate: null,
  },
};

const trialBalanceSlice = createSlice({
  name: "trialBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrialBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTrialBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.balances = action.payload || {};
      })
      .addCase(fetchTrialBalance.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || action.payload || "Failed to fetch records";
      });
  },
});

export const { setFilters } = trialBalanceSlice.actions;
export default trialBalanceSlice.reducer;
